import React, { useState } from "react"
import { Button } from "react-bootstrap"

import { withSampleConfig } from "../../../../config/SampleConfigProvider"
import { showModal, hideModal } from "../../../../shared_components/utils"
import TableSampleRoundTemplate from "./TableSampleRoundTemplate"
import ModalCreateSampleRoundTemplate from "./ModalCreateSampleRoundTemplate"
import { getFormattedMessage } from "../../../shared_components_registration"

/* Component for Sample Round Template management */
const SampleRoundTemplate = ({ user_permissions = [], getSampleRoundTemplates, updateMetrics, isNSView }) => {
  const [newTemplateModal, setNewTemplateModal] = useState(false)
  const initStatus = {
    sample_template_create_status: null,
    sample_template_create_error: {},
  }

  return (
    <div style={{ marginBottom: "70px" }}>
      <div className={"row"}>
        <div className={"col-4"}>
          <div style={{ margin: "5px 0px" }}>
            <span className={"fa fa-list-alt"} />
            &nbsp;&nbsp;
            {getFormattedMessage(
              `samplemanagement.${isNSView ? "ns" : "sample"}.rounds.templates`,
              `${isNSView ? "NS" : "Sample"} Round Templates`,
            )}
          </div>
        </div>
        <div className={"col-8"} align={"right"}>
          <Button
            variant={"outline-primary"}
            size={"sm"}
            onClick={(e) => {
              e.preventDefault()
              getSampleRoundTemplates()
            }}
            style={{ marginRight: "5px" }}
          >
            <span className={"fa fa-refresh"} />
            &nbsp;&nbsp;
            {getFormattedMessage("general.refresh", "Refresh")}
          </Button>
          <Button
            variant={"primary"}
            size={"sm"}
            disabled={!user_permissions.includes("add_sampleroundtemplate")}
            onClick={(e) => {
              e.preventDefault()
              showModal(setNewTemplateModal)
            }}
          >
            <span className={"fa fa-plus text_white"} />
            &nbsp;&nbsp;
            {getFormattedMessage("samplemanagement.create.template", "Create Template")}
          </Button>
        </div>
      </div>

      <hr style={{ margin: "10px 0px 25px 0px" }} />

      <TableSampleRoundTemplate />

      {newTemplateModal && user_permissions.includes("add_sampleroundtemplate") && (
        <ModalCreateSampleRoundTemplate
          show={newTemplateModal}
          onHide={() => {
            updateMetrics(initStatus)
            hideModal(setNewTemplateModal)
          }}
          initStatus={initStatus}
        />
      )}
    </div>
  )
}

export default withSampleConfig(SampleRoundTemplate)
